module.exports = __webpack_public_path__ + "img/129.4b6cf94.jpg";